import ApiBase from "../api-base";

class CompaniesApi extends  ApiBase {

    async getIndustries(page = 1, perPage = 100) {
        return this.handleResponse(async () => {
            let response = await this.get('/companies/industries');

            return response.data;
        });
    }

    async getCompany(id) {
        return this.handleResponse(async () => {
           const response = await this.get(`/companies/${id}`);
           return response.data.data;
        });
    }


    async update(id, params, validationCallback) {
        return this.handleResponse(async () => {
            const response = await this.post(`/companies/${id}`, params, validationCallback);
            return response.data.data;
        });
    }
    async getUserActions(id) {
        return this.handleResponse(async () => {
            const response = await this.get(`/companies/${id}/users/actions`);
            return response.data.data;
        });
    }

    async updateProfile(id, params, validationCallback) {
        return this.handleResponse(async () => {
            const response = await this.post(`/companies/${id}/profile`, params, validationCallback);
            return response.data.data;
        });
    }

    async users(id, page, perPage) {
        return this.handleResponse(async () => {
            const response = await this.get(`/companies/${id}/users`, {page, per_page : perPage});
            return response.data;
        });
    }

    async updateRoles(id, userId, params, validationCallback) {
        return this.handleResponse(async () => {
            const response = await this.post(`/companies/${id}/users/${userId}/roles`, params, validationCallback);
            return response.data.data;
        });
    }

    async userInvites(id, page, perPage) {
        return this.handleResponse(async () => {
            const response = await this.get(`/companies/${id}/users-invites`, {page, per_page : perPage});
            return response.data;
        });
    }

    async inviteUser(id, email, role_ids, validationCallback) {

           const response = await this.post(`/companies/${id}/invite-user`, {email,  role_ids }, validationCallback);
           return response.data;

    }
}


export default new CompaniesApi();
